import { defineAsyncComponent } from 'vue'
export * from './modal';

export const DatePickerComponent = defineAsyncComponent(() => import('./datepicker/components/Datepicker.vue'))
export const InputFieldComponent = defineAsyncComponent(() => import('./form/input-field-component.vue'))
export const FooterComponent = defineAsyncComponent(() => import('./footer-component.vue'))
export const DividerComponent = defineAsyncComponent(() => import('./divider-component.vue'))
export const InfoBoxComponent = defineAsyncComponent(() => import('./info-box-component.vue'))
export const EmptyStateComponent = defineAsyncComponent(() => import('./empty-state-component.vue'))
export const PlaceholderComponent = defineAsyncComponent(() => import('./placeholder-component.vue'))
export const SidebarComponent = defineAsyncComponent(() => import('./sidebar/sidebar-component.vue'))
export const HeaderComponent = defineAsyncComponent(() => import('./header-component.vue'))
export const PaginationComponent = defineAsyncComponent(() => import('./pagination-component.vue'))
export const SelectBoxComponent = defineAsyncComponent(() => import('./form/select-box-component.vue'))
export const AutoCompleteComponent = defineAsyncComponent(() => import('./form/autocomplete-component.vue'))
export const BadgeComponent = defineAsyncComponent(() => import("./badge-component.vue"));
